import { createApp } from 'vue'
import Teach from '@/Teach.vue'
import { router } from '@/router'
import { userModule } from '@/store/user/module'
import { analyticsModule } from '@/store/analytics/module'
import '@pocketprep/ui-kit/normalize'
import '@pocketprep/ui-kit/fonts'
import '@pocketprep/ui-kit/styles'
import './teach.scss'
import * as Sentry from '@sentry/vue'
import { SentryInit } from '@/sentry'

const app = createApp(Teach)

analyticsModule.actions.initAmplitude()
SentryInit(app)

app.use(router)

import PortalVue from 'portal-vue'
app.use(PortalVue)

app.config.errorHandler = (e) => {
    const error = e as Error | string
    if (error.toString().includes('Invalid session token')) {
        userModule.actions.signOut().then(() => {
            router.push({
                name: 'sign-in',
                query: {
                    error: 'Your session has expired. Please sign in again.',
                },
            }).catch(() => {
                // noop
            })
        })
    } else if (error instanceof Error) {
        Sentry.captureException(error)
        throw error
    } else {
        const newError = new Error(error)
        Sentry.captureException(newError)
        throw newError
    }
}

app.mount('#teach')
